<script>
  import radio from '~componentes/Radio.vue';

  export default {
    components: { radio },
    props: {
      inscricao: {
        type: Object,
        required: true
      },
      idCript: {
        type: String,
      },
      rotaAnterior: {
        type: String,
      },
      cadastroCompleto: {
        type: Number,
      },
      labelsLinguagemSelecionada: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        pessoaFisica: true,
      }
    },
    methods: {},
    computed: {
      valorSim(){
        return this.labelsLinguagemSelecionada.labels.simInscricao
      },
      valorNao(){
        return this.labelsLinguagemSelecionada.labels.naoInscricao
      },
    },
    mounted() {
    },
    created() {
      if (typeof this.inscricao.valor === "string") {
        this.inscricao.valor = this.$options.filters.formatarNumero(this.inscricao.valor, true);
      }
    }
  }
</script>

<template>
  <div>
    <div class="row">
      <dl class="col-xs-12">
        <dt>{{ this.labelsLinguagemSelecionada.labels.nomeInscricao }}</dt>
        <dd>
          {{ inscricao.nome }}
        </dd>
      </dl>
    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <dl class="col-xs-9">
        <dt>{{ this.labelsLinguagemSelecionada.labels.enderecoInscricao }}</dt>
        <dd>
          {{ inscricao.endereco }}
        </dd>
      </dl>

      <dl class="col-xs-3">
        <dt>{{ this.labelsLinguagemSelecionada.labels.numeroInscricao }}</dt>
        <dd>
          {{ inscricao.numero }}
        </dd>
      </dl>
    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <dl class="col-xs-7">
        <dt>{{ this.labelsLinguagemSelecionada.labels.complementoInscricao }}</dt>
        <dd>
          {{ inscricao.complemento }}
        </dd>
      </dl>

      <dl class="col-xs-5">
        <dt>{{ this.labelsLinguagemSelecionada.labels.cidadeInscricao }}</dt>
        <dd>
          {{ inscricao.cidade }}
        </dd>
      </dl>
    </div>

    <div class="row" v-if="cadastroCompleto == 1">
      <dl class="col-xs-4">
        <dt>{{ this.labelsLinguagemSelecionada.labels.telefoneInscricao }}</dt>
        <dd>
          {{ inscricao.telefone }}
        </dd>
      </dl>

      <dl class="col-xs-4">
        <dt>{{ this.labelsLinguagemSelecionada.labels.celularInscricao }}</dt>
        <dd>
          {{ inscricao.celular }}
        </dd>
      </dl>

      <dl class="col-xs-4">
        <dt>{{ this.labelsLinguagemSelecionada.labels.dataNascimentoInscricao }}</dt>
        <dd>
          {{ inscricao.dataNascimento }}
        </dd>
      </dl>
    </div>

    <div class="row">
      <dl class="col-xs-12">
        <dt>{{ this.labelsLinguagemSelecionada.labels.emailInscricao }}</dt>
        <dd>
          {{ inscricao.email }}
        </dd>
      </dl>
    </div>

    <div class="row">
      <dl class="col-xs-8" v-if="inscricao.faixaValores">
        <dt>{{ this.labelsLinguagemSelecionada.labels.categoriasInscricao }}</dt>
        <dd>
          {{ inscricao.faixaValores }}
        </dd>
      </dl>

      <dl class="col-xs-8" v-if="!inscricao.faixaValores">
        <dt></dt>
        <dd></dd>
      </dl>

      <dl class="col-xs-3">
        <dt>{{ this.labelsLinguagemSelecionada.labels.valorCategoriaInscricao }}</dt>
        <dd>
          {{ inscricao.valor | formatarNumero }}
        </dd>
      </dl>
    </div>

    <div class="row" v-if="inscricao.selecaoCategoria">
      <dl class="col-xs-12">
        <dd>
          {{ inscricao.selecaoCategoria }}
        </dd>
      </dl>
    </div>

    <div class="hr-line-dashed margin-top-20"></div>

    <div v-if="inscricao.questionarios.length > 0">
      <span class="font-bold">{{ this.labelsLinguagemSelecionada.labels.questionarioInscricao }}:</span>

      <div style="padding-top: 20px;"></div>

      <div v-for="(questionario, index) in inscricao.questionarios">
        <div class="row">
          <dl class="col-xs-12">
            <dt>{{index + 1}} - {{questionario.pergunta}}</dt>
          </dl>
        </div>

        <div class="row">
          <dl class="col-xs-12" v-if="questionario.tipoResposta == 1">
            <dd>{{typeof  questionario.selecionado === "string" ? questionario.selecionado === 'true' ? valorSim : valorNao : questionario.selecionado == true ? valorSim : valorNao}}</dd>
          </dl>

          <dl class="col-xs-12" v-if="questionario.tipoResposta == 2 | questionario.tipoResposta == 3">
            <dd>{{ questionario.campoResposta }}</dd>
          </dl>
        </div>
      </div>

      <div class="hr-line-dashed margin-top-20"></div>
    </div>

    <div v-if="inscricao.valor > 0">
      <span class="font-bold">{{ this.labelsLinguagemSelecionada.labels.meioPagamentoInscricao }}</span>

      <div class="hr-line-dashed margin-top-20"></div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/acessos/componentes/compartilhado/AcessosInscricaoResumoEstrangeiro.vue